import { gray, blackAlpha, azure, green, yellow, orange, red, blue, purple, rose, magenta, cyan } from '../../colors.mjs';

var color = {
  'color-bg': {
    value: gray[6]
  },
  'color-bg-inverse': {
    value: gray[16]
  },
  'color-bg-surface': {
    value: gray[1]
  },
  'color-bg-surface-active': {
    value: gray[5]
  },
  'color-bg-surface-hover': {
    value: gray[4]
  },
  'color-bg-surface-selected': {
    value: gray[6]
  },
  'color-bg-surface-disabled': {
    value: blackAlpha[5]
  },
  'color-bg-surface-secondary': {
    value: gray[4]
  },
  'color-bg-surface-secondary-hover': {
    value: gray[6]
  },
  'color-bg-surface-secondary-active': {
    value: gray[7]
  },
  'color-bg-surface-secondary-selected': {
    value: gray[7]
  },
  'color-bg-surface-tertiary': {
    value: gray[5]
  },
  'color-bg-surface-tertiary-hover': {
    value: gray[7]
  },
  'color-bg-surface-tertiary-active': {
    value: gray[8]
  },
  'color-bg-surface-brand': {
    value: gray[8]
  },
  'color-bg-surface-brand-hover': {
    value: gray[7]
  },
  'color-bg-surface-brand-active': {
    value: gray[6]
  },
  'color-bg-surface-brand-selected': {
    value: gray[6]
  },
  'color-bg-surface-info': {
    value: azure[3]
  },
  'color-bg-surface-info-hover': {
    value: azure[4]
  },
  'color-bg-surface-info-active': {
    value: azure[6]
  },
  'color-bg-surface-success': {
    value: green[3]
  },
  'color-bg-surface-success-hover': {
    value: green[4]
  },
  'color-bg-surface-success-active': {
    value: green[5]
  },
  'color-bg-surface-caution': {
    value: yellow[2]
  },
  'color-bg-surface-caution-hover': {
    value: yellow[3]
  },
  'color-bg-surface-caution-active': {
    value: yellow[4]
  },
  'color-bg-surface-warning': {
    value: orange[3]
  },
  'color-bg-surface-warning-hover': {
    value: orange[4]
  },
  'color-bg-surface-warning-active': {
    value: orange[5]
  },
  'color-bg-surface-critical': {
    value: red[4]
  },
  'color-bg-surface-critical-hover': {
    value: red[5]
  },
  'color-bg-surface-critical-active': {
    value: red[6]
  },
  'color-bg-surface-emphasis': {
    value: blue[3]
  },
  'color-bg-surface-emphasis-hover': {
    value: blue[4]
  },
  'color-bg-surface-emphasis-active': {
    value: blue[5]
  },
  'color-bg-surface-magic': {
    value: purple[3]
  },
  'color-bg-surface-magic-hover': {
    value: purple[4]
  },
  'color-bg-surface-magic-active': {
    value: purple[6]
  },
  'color-bg-surface-inverse': {
    value: gray[15]
  },
  'color-bg-surface-transparent': {
    value: blackAlpha[1]
  },
  'color-bg-fill': {
    value: gray[1]
  },
  'color-bg-fill-hover': {
    value: gray[3]
  },
  'color-bg-fill-active': {
    value: gray[4]
  },
  'color-bg-fill-selected': {
    value: gray[10]
  },
  'color-bg-fill-disabled': {
    value: blackAlpha[5]
  },
  'color-bg-fill-secondary': {
    value: gray[6]
  },
  'color-bg-fill-secondary-hover': {
    value: gray[7]
  },
  'color-bg-fill-secondary-active': {
    value: gray[8]
  },
  'color-bg-fill-tertiary': {
    value: gray[8]
  },
  'color-bg-fill-tertiary-hover': {
    value: gray[9]
  },
  'color-bg-fill-tertiary-active': {
    value: gray[10]
  },
  'color-bg-fill-brand': {
    value: gray[15]
  },
  'color-bg-fill-brand-hover': {
    value: gray[16]
  },
  'color-bg-fill-brand-active': {
    value: gray[16]
  },
  'color-bg-fill-brand-selected': {
    value: gray[15]
  },
  'color-bg-fill-brand-disabled': {
    value: blackAlpha[9]
  },
  'color-bg-fill-info': {
    value: azure[9]
  },
  'color-bg-fill-info-hover': {
    value: azure[10]
  },
  'color-bg-fill-info-active': {
    value: azure[11]
  },
  'color-bg-fill-info-secondary': {
    value: azure[4]
  },
  'color-bg-fill-success': {
    value: green[12]
  },
  'color-bg-fill-success-hover': {
    value: green[13]
  },
  'color-bg-fill-success-active': {
    value: green[14]
  },
  'color-bg-fill-success-secondary': {
    value: green[3]
  },
  'color-bg-fill-warning': {
    value: orange[9]
  },
  'color-bg-fill-warning-hover': {
    value: orange[10]
  },
  'color-bg-fill-warning-active': {
    value: orange[11]
  },
  'color-bg-fill-warning-secondary': {
    value: orange[7]
  },
  'color-bg-fill-caution': {
    value: yellow[6]
  },
  'color-bg-fill-caution-hover': {
    value: yellow[8]
  },
  'color-bg-fill-caution-active': {
    value: yellow[9]
  },
  'color-bg-fill-caution-secondary': {
    value: yellow[4]
  },
  'color-bg-fill-critical': {
    value: red[12]
  },
  'color-bg-fill-critical-hover': {
    value: red[13]
  },
  'color-bg-fill-critical-active': {
    value: red[14]
  },
  'color-bg-fill-critical-selected': {
    value: red[14]
  },
  'color-bg-fill-critical-secondary': {
    value: red[6]
  },
  'color-bg-fill-emphasis': {
    value: blue[13]
  },
  'color-bg-fill-emphasis-hover': {
    value: blue[14]
  },
  'color-bg-fill-emphasis-active': {
    value: blue[15]
  },
  'color-bg-fill-magic': {
    value: purple[12]
  },
  'color-bg-fill-magic-secondary': {
    value: purple[6]
  },
  'color-bg-fill-magic-secondary-hover': {
    value: purple[7]
  },
  'color-bg-fill-magic-secondary-active': {
    value: purple[8]
  },
  'color-bg-fill-inverse': {
    value: gray[15]
  },
  'color-bg-fill-inverse-hover': {
    value: gray[14]
  },
  'color-bg-fill-inverse-active': {
    value: gray[13]
  },
  'color-bg-fill-transparent': {
    value: blackAlpha[3]
  },
  'color-bg-fill-transparent-hover': {
    value: blackAlpha[5]
  },
  'color-bg-fill-transparent-active': {
    value: blackAlpha[7]
  },
  'color-bg-fill-transparent-selected': {
    value: blackAlpha[7]
  },
  'color-bg-fill-transparent-secondary': {
    value: blackAlpha[6]
  },
  'color-bg-fill-transparent-secondary-hover': {
    value: blackAlpha[7]
  },
  'color-bg-fill-transparent-secondary-active': {
    value: blackAlpha[8]
  },
  'color-text': {
    value: gray[15]
  },
  'color-text-secondary': {
    value: gray[13]
  },
  'color-text-disabled': {
    value: gray[11]
  },
  'color-text-link': {
    value: blue[13]
  },
  'color-text-link-hover': {
    value: blue[14]
  },
  'color-text-link-active': {
    value: blue[15]
  },
  'color-text-brand': {
    value: gray[14]
  },
  'color-text-brand-hover': {
    value: gray[15]
  },
  'color-text-brand-on-bg-fill': {
    value: gray[1]
  },
  'color-text-brand-on-bg-fill-hover': {
    value: gray[8]
  },
  'color-text-brand-on-bg-fill-active': {
    value: gray[10]
  },
  'color-text-brand-on-bg-fill-disabled': {
    value: gray[1]
  },
  'color-text-info': {
    value: azure[14]
  },
  'color-text-info-hover': {
    value: azure[15]
  },
  'color-text-info-active': {
    value: azure[16]
  },
  'color-text-info-on-bg-fill': {
    value: azure[16]
  },
  'color-text-success': {
    value: green[14]
  },
  'color-text-success-hover': {
    value: green[15]
  },
  'color-text-success-active': {
    value: green[16]
  },
  'color-text-success-on-bg-fill': {
    value: green[1]
  },
  'color-text-caution': {
    value: yellow[14]
  },
  'color-text-caution-hover': {
    value: yellow[15]
  },
  'color-text-caution-active': {
    value: yellow[16]
  },
  'color-text-caution-on-bg-fill': {
    value: yellow[15]
  },
  'color-text-warning': {
    value: orange[14]
  },
  'color-text-warning-hover': {
    value: orange[15]
  },
  'color-text-warning-active': {
    value: orange[16]
  },
  'color-text-warning-on-bg-fill': {
    value: orange[16]
  },
  'color-text-critical': {
    value: red[14]
  },
  'color-text-critical-hover': {
    value: red[15]
  },
  'color-text-critical-active': {
    value: red[16]
  },
  'color-text-critical-on-bg-fill': {
    value: red[1]
  },
  'color-text-emphasis': {
    value: blue[13]
  },
  'color-text-emphasis-hover': {
    value: blue[14]
  },
  'color-text-emphasis-active': {
    value: blue[15]
  },
  'color-text-emphasis-on-bg-fill': {
    value: blue[1]
  },
  'color-text-emphasis-on-bg-fill-hover': {
    value: blue[5]
  },
  'color-text-emphasis-on-bg-fill-active': {
    value: blue[7]
  },
  'color-text-magic': {
    value: purple[14]
  },
  'color-text-magic-on-bg-fill': {
    value: purple[1]
  },
  'color-text-inverse': {
    value: gray[8]
  },
  'color-text-inverse-secondary': {
    value: gray[11]
  },
  'color-text-link-inverse': {
    value: blue[8]
  },
  'color-border': {
    value: gray[8]
  },
  'color-border-hover': {
    value: gray[10]
  },
  'color-border-disabled': {
    value: gray[7]
  },
  'color-border-secondary': {
    value: gray[7]
  },
  'color-border-tertiary': {
    value: gray[10]
  },
  'color-border-focus': {
    value: blue[13]
  },
  'color-border-brand': {
    value: gray[8]
  },
  'color-border-info': {
    value: azure[8]
  },
  'color-border-success': {
    value: green[5]
  },
  'color-border-caution': {
    value: yellow[5]
  },
  'color-border-warning': {
    value: orange[8]
  },
  'color-border-critical': {
    value: red[8]
  },
  'color-border-critical-secondary': {
    value: red[14]
  },
  'color-border-emphasis': {
    value: blue[13]
  },
  'color-border-emphasis-hover': {
    value: blue[14]
  },
  'color-border-emphasis-active': {
    value: blue[15]
  },
  'color-border-magic': {
    value: purple[10]
  },
  'color-border-magic-secondary': {
    value: purple[12]
  },
  'color-border-inverse': {
    value: gray[13]
  },
  'color-border-inverse-hover': {
    value: gray[10]
  },
  'color-border-inverse-active': {
    value: gray[8]
  },
  'color-icon': {
    value: gray[14]
  },
  'color-icon-hover': {
    value: gray[15]
  },
  'color-icon-active': {
    value: gray[16]
  },
  'color-icon-disabled': {
    value: gray[10]
  },
  'color-icon-secondary': {
    value: gray[12]
  },
  'color-icon-secondary-hover': {
    value: gray[13]
  },
  'color-icon-secondary-active': {
    value: gray[14]
  },
  'color-icon-brand': {
    value: gray[16]
  },
  'color-icon-info': {
    value: azure[11]
  },
  'color-icon-success': {
    value: green[12]
  },
  'color-icon-caution': {
    value: yellow[11]
  },
  'color-icon-warning': {
    value: orange[11]
  },
  'color-icon-critical': {
    value: red[11]
  },
  'color-icon-emphasis': {
    value: blue[13]
  },
  'color-icon-emphasis-hover': {
    value: blue[14]
  },
  'color-icon-emphasis-active': {
    value: blue[15]
  },
  'color-icon-magic': {
    value: purple[12]
  },
  'color-icon-inverse': {
    value: gray[8]
  },
  'color-avatar-bg-fill': {
    value: gray[11]
  },
  'color-avatar-five-bg-fill': {
    value: rose[7]
  },
  'color-avatar-five-text-on-bg-fill': {
    value: rose[14]
  },
  'color-avatar-four-bg-fill': {
    value: azure[7]
  },
  'color-avatar-four-text-on-bg-fill': {
    value: azure[14]
  },
  'color-avatar-one-bg-fill': {
    value: magenta[7]
  },
  'color-avatar-one-text-on-bg-fill': {
    value: magenta[14]
  },
  'color-avatar-text-on-bg-fill': {
    value: gray[1]
  },
  'color-avatar-three-bg-fill': {
    value: cyan[7]
  },
  'color-avatar-three-text-on-bg-fill': {
    value: cyan[14]
  },
  'color-avatar-two-bg-fill': {
    value: green[7]
  },
  'color-avatar-two-text-on-bg-fill': {
    value: green[14]
  },
  'color-backdrop-bg': {
    value: blackAlpha[14]
  },
  'color-checkbox-bg-surface-disabled': {
    value: blackAlpha[7]
  },
  'color-checkbox-icon-disabled': {
    value: gray[1]
  },
  'color-input-bg-surface': {
    value: gray[2]
  },
  'color-input-bg-surface-hover': {
    value: gray[3]
  },
  'color-input-bg-surface-active': {
    value: gray[4]
  },
  'color-input-border': {
    value: gray[12]
  },
  'color-input-border-hover': {
    value: gray[13]
  },
  'color-input-border-active': {
    value: gray[16]
  },
  'color-nav-bg': {
    value: gray[7]
  },
  'color-nav-bg-surface': {
    value: blackAlpha[3]
  },
  'color-nav-bg-surface-hover': {
    value: gray[6]
  },
  'color-nav-bg-surface-active': {
    value: gray[3]
  },
  'color-nav-bg-surface-selected': {
    value: gray[3]
  },
  'color-radio-button-bg-surface-disabled': {
    value: blackAlpha[7]
  },
  'color-radio-button-icon-disabled': {
    value: gray[1]
  },
  'color-video-thumbnail-play-button-bg-fill-hover': {
    value: blackAlpha[15]
  },
  'color-video-thumbnail-play-button-bg-fill': {
    value: blackAlpha[14]
  },
  'color-video-thumbnail-play-button-text-on-bg-fill': {
    value: gray[1]
  }
};

export { color };
